import { Spinner, Tag, TagCloseButton } from '@chakra-ui/react';
import { Spin, notification } from 'antd';
import useCart from 'hooks/useCart';
import useCatchError from 'hooks/useCatchError';
import useUser from 'hooks/useUser';
import { IPromotionCoupon } from 'interfaces/promotion.interface';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CartRepository } from 'respository/cart.repository';

type CartCouponItemProps = {
  coupon: IPromotionCoupon;
};

function CartCouponItem({ coupon }: CartCouponItemProps) {
  const { user } = useUser();

  const { t } = useTranslation(['cart']);

  // use cart
  const { cart, cartMutate } = useCart();

  // use catch error hook
  const catchError = useCatchError();

  // loading
  const [couponRemoveLoading, setCouponRemoveLoading] = React.useState(false);

  const handleRemoveCoupon = async () => {
    try {
      setCouponRemoveLoading(true);

      if (user && user.isAuthenticated) {
        const cartUpdated = await CartRepository.removeCoupon(coupon.id);

        // show notification
        notification.success({
          message: t('cart.coupon.remove.success.message'),
          description: t('cart.coupon.remove.success.description'),
          // TH: คุณได้ลบคูปองสำเร็จแล้ว
          // EN: You have successfully removed the coupon.
        });

        cartMutate({
          ...cart,
          ...cartUpdated,
        });
      } else {
        alert('โปรดเข้าสู่ระบบก่อน');
      }
    } catch (error) {
      catchError(error);
    } finally {
      setCouponRemoveLoading(false);
    }
  };

  return (
    <Tag
      key={coupon.id}
      colorScheme={coupon.available ? 'primary' : 'gray'}
      size="md"
      variant="solid"
    >
      {coupon.code}
      {couponRemoveLoading ? (
        <Spinner size="xs" ml={2}></Spinner>
      ) : (
        <TagCloseButton onClick={handleRemoveCoupon} />
      )}
    </Tag>
  );
}

export default CartCouponItem;
